export var firebaseConfig = {
    apiKey: 'AIzaSyDGD4F56j1dMxA8hgrLAK2OTMxCASxdqVo',
    authDomain: 'lasaro-dynamic-options.firebaseapp.com',
    projectId: 'lasaro-dynamic-options',
    storageBucket: 'lasaro-dynamic-options.appspot.com',
    messagingSenderId: '821177006562',
    appId: '1:821177006562:web:86f52d16303860c5a361bb',
    measurementId: 'G-G5NC19MY9N',
};
